/* eslint-disable import/prefer-default-export */
import { atom } from 'recoil';
import { ITransitionPackage } from './types.d';

export const TransitionPackageAtom = atom<null | ITransitionPackage>({
  key: 'TransitionPackageAtom',
  default: null,
});
